import Interaction from "../../../models/interactions/Interaction";
import { LisaMessage } from "../../../models/interactions/LisaMessage";
import SequenceLocalizedRichTextField from "../components/SequenceLocalizedRichTextField";

export default function LisaMessageNodePreview(props: {
  nodeId: string;
  interaction: Interaction;
}) {
  const lm = props.interaction as LisaMessage;

  return (
    <div className="w-full h-full">
      <SequenceLocalizedRichTextField
        label="Message"
        placeholder="Message"
        localizationKey={lm.message}
      />
    </div>
  );
}
